<template>
  <div>
    <ul class="nav nav-pills" style="" id="myTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link tab-link" role="tab" @click="$emit('click', true)" :class="isSelectPrint ? 'active' : ''">印刷元データ</a>
      </li>
      <li class="nav-item">
        <a class="nav-link tab-link" role="tab" @click="$emit('click', false)" :class="!isSelectPrint ? 'active' : ''">棚卸対象データ</a>
      </li>
    </ul>
    <br>
  </div>
</template>

<script>

export default {
  name: 'stock-data-set-tab',
  props: {
    isSelectPrint: {
      type: Boolean,
      default: true
    }
  },

  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/StockDataSetTab.vue